import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(-1);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-14 items-start">
          <div data-reveal>
            <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
              常见问题
            </h2>
            <p className="mt-4 text-foreground-600 leading-8">
              关于本站定位、版本区别与浏览方式，这里集中回答最常被问到的几个问题。
              点击问题即可展开答案。
            </p>
            <div className="mt-6 p-5 rounded-xl bg-background-50 border border-background-200">
              <div className="flex items-center gap-2 text-primary-600 text-sm font-medium">
                <i className="ri-question-answer-line" aria-hidden="true"></i>
                还有别的疑问？
              </div>
              <p className="mt-2 text-xs text-foreground-600 leading-6">
                若想了解某个具体题材的展开，可回到「题材选片」按标签筛选，或查看「剧情看点」中的叙事说明。
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((f, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={f.q}
                  data-reveal
                  className="rounded-xl bg-background-50 border border-background-200 overflow-hidden"
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="w-full flex items-center gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/60 transition-colors"
                  >
                    <span className="flex-1 font-medium text-foreground-900">{f.q}</span>
                    <i
                      className={
                        isOpen
                          ? "ri-arrow-up-s-line text-xl text-primary-600"
                          : "ri-arrow-down-s-line text-xl text-foreground-500"
                      }
                      aria-hidden="true"
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-7">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}